import { getUserDetails } from '../../actions/userActions';
import { hasCourses } from '../../utils/learningCourseUtils';
import Messages from '../includes/Messages';
import PromoBox from '../includes/PromoBox';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router';

/**
 * Container for our lists of form options.
 *
 * Should show a login form if we're logged out.
 */

const Dashboard = ({ dashboard, content, tilesContent, sessionId, userHasCourses, learningTileDescription, getUserDetails }) => {
  // Fetch user details on load
  useEffect(() => {
    if (sessionId !== null) {
      getUserDetails(sessionId);
    }
  }, [sessionId, getUserDetails]);

  // Prepare data for display
  let tiles = [];
  if (typeof dashboard.tiles !== 'undefined') {
    // Sort tiles according to sort order set in config
    tiles = dashboard.tiles.slice(0);
    tiles.sort((a, b) => {
      for (let i = 0, ii = content.tileOrder.length; i < ii; i++) {
        if (content.tileOrder[i] === a.type) return -1;
        if (content.tileOrder[i] === b.type) return 1;
      }
      return 0;
    });
  }

  const location = useLocation();
  let bannerHtml = { __html: content.banner.content };
  const breadCrumbs = [{ title: 'dashboard', url: location.pathname }];

  return (
    <>
      {/* Intro */}
      {content.intro ? (
        <PromoBox>
          <p className="intro">{content.intro}</p>
        </PromoBox>
      ) : null}

      <section>
        {/* Editable forms */}
        <div className="container content">
          <div className="row middle">
            <div className="col-lg-12">
              <Messages />
            </div>

            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
              {tiles.map((tile) => {
                const tlContent = tilesContent[tile.type] || {};
                return (
                  <div key={tile.type} className="col frank-tile">
                    <Link
                      to={{ pathname: tile.subTiles ? '/sub/' + tile.type : '/forms/' + tile.type }}
                      state={{ breadCrumbs: breadCrumbs }}
                    >
                      <div className="bg-mint p-4 h-100">
                        <h3>{tile.title}</h3>
                        {tlContent.intro && <p>{tlContent.intro}</p>}
                      </div>
                    </Link>
                  </div>
                );
              })}
              {userHasCourses && (
                <div className="col frank-tile">
                  <Link to="/learning" state={{ breadCrumbs: breadCrumbs }}>
                    <div className="bg-mint p-4 h-100">
                      <h3>Learning</h3>
                      {learningTileDescription && <p>{learningTileDescription}</p>}
                    </div>
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Banner */}
      {content.banner.content ? (
        <div className="page-title bg-black">
          <img alt={content.banner.title} src="/assets/Uploads/Photos/banner-about.jpg" className="banner hidden-sm hidden-xs" />
          <div className="container">
            <div className="row banner hidden-sm hidden-xs">
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="img-overlay bg-black">
                  <div className="content-wrap ">
                    <span className="fi-stack fi-3x">
                      <i className="fi fi-circle-solid fi-stack-2x"></i>
                      <i className="fi fi-building fi-stack-1x fi-inverse"></i>
                    </span>

                    {content.banner.title ? <h2>{content.banner.title}</h2> : null}
                    {/* eslint-disable-next-line @eslint-react/dom-no-dangerously-set-innerhtml */}
                    <div className="typography" dangerouslySetInnerHTML={bannerHtml} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

const mapStateToProps = (state) => ({
  dashboard: state.dashboard,
  content: state.config.content.dashboard,
  tilesContent: state.config.content.tiles,
  sessionId: state.user.sessionId,
  userHasCourses: hasCourses(state.user.details),
  learningTileDescription: state.config.content?.learningTileDescription,
});

const mapDispatchToProps = {
  getUserDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
